import { AuthActionTypes } from './actionTypes';
import * as API from '../../API/userAPI';
import storage from 'Utility/storage';
import { toastMsg } from 'Utility/utility';
import * as actions from './index';

export const editprofile = (credentials) => {
   return (dispatch, getState) => {
      dispatch({
         type: AuthActionTypes.PROFILE,
         payload: API.updateUser(credentials)
            .then((response) => {
               if (
                  response.data.success === true ||
                  response.data.success === 'true'
               ) {
                  dispatch(actions.userAPI());
                  storage.set('user', response.data.user);
                  toastMsg('User updated successfully! ');
               }
               return response.data;
            })
            .catch((error) => {
               console.log(error);
               return error;
            }),
      });
   };
};

export const plans = () => {
   return (dispatch, getState) => {
      dispatch({
         type: AuthActionTypes.PLANS,
         payload: API.plans()
            .then((response) => {
               if (
                  response.data.success === true ||
                  response.data.success === 'true'
               ) {
                  dispatch(actions.userAPI());
                  return response.data;
               }
            })
            .catch((error) => {
               console.log(error);
               return error;
            }),
      });
   };
};

export const addCard = (token, data) => {
   return (dispatch, getState) => {
      dispatch({
         type: AuthActionTypes.ADDCARD,
         payload: API.addcard(token)
            .then((response) => {
               if (
                  response.data.success === true ||
                  response.data.success === 'true'
               ) {
                  dispatch(actions.subscribe(data));
               }
               return response.data;
            })
            .catch((error) => {
               console.log(error);
               return error;
            }),
      });
   };
};

export const planid = (planid) => {
   return (dispatch) =>
      dispatch({
         type: AuthActionTypes.PLANID,
         payload: {
            planid: planid,
         },
      });
};

export const planName = (planName) => {
   return (dispatch) =>
      dispatch({
         type: AuthActionTypes.PLANNAME,
         payload: {
            planName: planName,
         },
      });
};

export const planPrice = (planPrice) => {
   return (dispatch) =>
      dispatch({
         type: AuthActionTypes.PLANPRICE,
         payload: {
            planPrice: planPrice,
         },
      });
};

export const subscribe = (product_id) => {
   return (dispatch, getState) => {
      dispatch({
         type: AuthActionTypes.SUBSCRIBE,
         payload: API.subscribe(product_id)
            .then((response) => {
               if (
                  response.data.success === true ||
                  response.data.success === 'true'
               ) {
                  dispatch(actions.userAPI());
                  dispatch(actions.getSub());
                  toastMsg('You have successfully Subscribed');
               }
               return response.data;
            })
            .catch((error) => {
               console.log(error);
               return error;
            }),
      });
   };
};

export const getSub = () => {
   return (dispatch, getState) => {
      dispatch({
         type: AuthActionTypes.GETSUB,
         payload: API.getSub()
            .then((response) => {
               if (
                  response.data.success === true ||
                  response.data.success === 'true'
               ) {
                  return response.data;
               }
            })
            .catch((error) => {
               console.log(error);
               return error;
            }),
      });
   };
};

export const cancelSub = () => {
   return (dispatch, getState) => {
      dispatch({
         type: AuthActionTypes.CANCELSUB,
         payload: API.cancelSub()
            .then((response) => {
               if (
                  response.data.success === true ||
                  response.data.success === 'true'
               ) {
                  dispatch(actions.userAPI());
                  toastMsg('You have successfully cancelled the Subscription');
                  return response.data;
               }
            })
            .catch((error) => {
               console.log(error);
               return error;
            }),
      });
   };
};

export const couponCheck = (coupon, planid) => {
   return (dispatch, getState) => {
      dispatch({
         type: AuthActionTypes.COUPONCHECK,
         payload: API.couponCheck(coupon, planid)
            .then((response) => {
               if (
                  response.data.success === true ||
                  response.data.success === 'true'
               ) {
                  return response.data;
               }
            })
            .catch((error) => {
               return error;
            }),
      });
   };
};

export const clearCoupon = () => (dispatch) => {
   dispatch({
      type: AuthActionTypes.CLEARCOUPON,
   });
};
